module.exports = __webpack_public_path__ + "img/sel_Hong Kong-.806fb5ed.png";